import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from 'react-bootstrap/Card'
import '../../index.css'
import {useEffect, useState} from 'react'
import axios from 'axios'
import dayjs from 'dayjs'
import {
  Column,
  Table as ReactTable,
  PaginationState,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  ColumnDef,
  OnChangeFn,
  flexRender,
} from '@tanstack/react-table'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom';
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'
// import imgSketchy17 from '../../../../../public/media/illustrations/sketchy-1/17.png'
// import flatpickr from "flatpickr";

export function TargetGroupManagement() {
  const navigate = useNavigate();
  const editItem = (data: any) => {
    console.log(data.original)
    navigate('/EditParticipant', {state: data.original});
  };
  const [tableData, setTableData] = useState<any>([])
  //const rerender = React.useReducer(() => ({}), {})[1]
  const API_URL = process.env.REACT_APP_API_URL
  const [header, setHeader] = useState([
    100
  ])
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      
      {
        accessorKey: 'point',
        header: 'เพิ่มคะแนน',
        footer: (props) => props.column.id,
        cell: (props) => <span className='ml-4'>+{Number(props.row.original.point).toFixed(0)}</span>,
      },
      {
        accessorKey: 'event_type',
        header: '	รายละเอียด',
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'participant.firstname',
        header: '	ชื่อ-นามสกุล',
        footer: (props) => props.column.id,
        cell: (props) => <span>{props.row.original.participant.firstname} {props.row.original.participant.lastname}</span>,
      },
      {
        accessorKey: 'created_at',
        header: 'วันที่',
        footer: (props) => props.column.id,
        cell: (props) => <span>{dayjs(props.row.original.created_at).format('DD-MM-YYYY')}</span>,
      },
    ],
    []
  )

  const [data, setData] = React.useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPage, setTotalPage] = useState(1)
  const [totalRow, setTotalRow] = useState(10)
  const getAPI = async () => {
    const data = await axios.get(`${API_URL}/bo/participant/history?page=1&limit=10`).then((res) => {
      setTableData(res.data.data)
      setData(() => res.data.data)
      setPage(res.data.page)
      setLimit(res.data.limit)
      setTotalRow(res.data.total)
      setTotalPage(Math.ceil(res.data.total / res.data.limit))
    })
    //return data.data.data
  }

  const refreshAPI = async (page: Number, limit: Number) => {
    const data = await axios
      .get(`${API_URL}/bo/participant/history?page=${page}&limit=${limit}`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
  }

  const [searchTerm, setSearchTerm] = useState<string>('')
  const refreshAPISearch = async (search: string) => {
    setSearchTerm(search)
    const data = await axios
      .get(`${API_URL}/bo/participant/history?page=${1}&limit=${limit}&search=${search}`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setPage(1)
        setTotalRow(res.data.total)
        setTotalPage(Math.ceil(res.data.total / res.data.limit))
      })
  }
  const table = useReactTable({
    data,
    columns,
    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    //
    debugTable: true,
  })
  useEffect(
    () => {
      getAPI()
    },
    [] // Only re-call effect if value or delay changes
  )
  const widthData = [0,40,40,40]
  
  return (


    <Card className='table-responsive'>
      <Card.Header>
        <div className='d-flex align-items-center position-relative my-1 d-none'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search user'
            value={searchTerm}
            onChange={(e) => refreshAPISearch(e.target.value)}
          />
        </div>
        {/** add button จุดเพิ่มปุ่ม */}
        <div className='d-flex justify-content-end card-title' data-kt-user-table-toolbar='base'>
          {/*<button type='button' className='btn btn-light-primary me-3'>
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>*/}

          {/*<button type='button' className='btn btn-primary' onClick={() => {}}>
            <KTIcon iconName='plus' className='fs-2' />
            Add Banner
          </button>*/}
        </div>
      </Card.Header>

          
      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body">
              <div className="card-px text-center pt-15 pb-15">
                <h2 className="fs-2x fw-bold mb-0">New Target Group</h2>
                <p className="text-gray-400 fs-4 fw-semibold py-7">Click on the below buttons to launch
                <br />a new target group.</p>
                <a href="#" className="btn btn-primary er fs-6 px-8 py-4" data-bs-toggle="modal" data-bs-target="#kt_modal_new_target">Add New Target</a>
              </div>
              <div className="text-center pb-15 px-5">
                <img src={'https://preview.keenthemes.com/metronic8/demo8/assets/media/illustrations/sketchy-1/2.png'} alt="" className="mw-100 h-200px h-sm-325px" />
                {/* assets/media/illustrations/sketchy-1/17.png */}
              </div>
            </div>
          </div>
        </div>
      </div>
      
		<div className="modal fade" id="kt_modal_new_target" tabIndex={-1} aria-hidden="true">
			<div className="modal-dialog modal-dialog-centered mw-650px">
				<div className="modal-content rounded">
					<div className="modal-header pb-0 border-0 justify-content-end">
						<div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
							<i className="ki-duotone ki-cross fs-1">
								<span className="path1"></span>
								<span className="path2"></span>
							</i>
						</div>
					</div>
					<div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
						<form id="kt_modal_new_target_form" className="form" action="#">
							<div className="mb-13 text-center">
								<h1 className="mb-3">Set First Target</h1>
								<div className="text-muted fw-semibold fs-5">If you need more info, please check
								<a href="#" className="fw-bold link-primary">Project Guidelines</a>.</div>
							</div>
							<div className="d-flex flex-column mb-8 fv-row">
								<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
									<span className="required">Target Title</span>
									<span className="ms-1" data-bs-toggle="tooltip" title="Specify a target name for future usage and reference">
										<i className="ki-duotone ki-information-5 text-gray-500 fs-6">
											<span className="path1"></span>
											<span className="path2"></span>
											<span className="path3"></span>
										</i>
									</span>
								</label>
								<input type="text" className="form-control form-control-solid" placeholder="Enter Target Title" name="target_title" />
							</div>
							<div className="row g-9 mb-8">
								<div className="col-md-6 fv-row">
									<label className="required fs-6 fw-semibold mb-2">Assign</label>
									<select className="form-select form-select-solid" data-control="select2" data-hide-search="true" data-placeholder="Select a Team Member" name="target_assign">
										<option value="">Select user...</option>
										<option value="1">Karina Clark</option>
										<option value="2">Robert Doe</option>
										<option value="3">Niel Owen</option>
										<option value="4">Olivia Wild</option>
										<option value="5">Sean Bean</option>
									</select>
								</div>
								<div className="col-md-6 fv-row">
									<label className="required fs-6 fw-semibold mb-2">Due Date</label>
									<div className="position-relative d-flex align-items-center">
										<i className="ki-duotone ki-calendar-8 fs-2 position-absolute mx-4">
											<span className="path1"></span>
											<span className="path2"></span>
											<span className="path3"></span>
											<span className="path4"></span>
											<span className="path5"></span>
											<span className="path6"></span>
										</i>
										<input className="form-control form-control-solid ps-12" placeholder="Select a date" name="due_date" />
									</div>
								</div>
							</div>
							<div className="d-flex flex-column mb-8">
								<label className="fs-6 fw-semibold mb-2">Target Details</label>
								<textarea className="form-control form-control-solid" rows={3} name="target_details" placeholder="Type Target Details"></textarea>
							</div>
							<div className="d-flex flex-column mb-8 fv-row">
								<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
									<span className="required">Tags</span>
									<span className="ms-1" data-bs-toggle="tooltip" title="Specify a target priorty">
										<i className="ki-duotone ki-information-5 text-gray-500 fs-6">
											<span className="path1"></span>
											<span className="path2"></span>
											<span className="path3"></span>
										</i>
									</span>
								</label>
								<input className="form-control form-control-solid" value="Important, Urgent" name="tags" />
							</div>
							<div className="d-flex flex-stack mb-8">
								<div className="me-5">
									<label className="fs-6 fw-semibold">Adding Users by Team Members</label>
									<div className="fs-7 fw-semibold text-muted">If you need more info, please check budget planning</div>
								</div>
								<label className="form-check form-switch form-check-custom form-check-solid">
									<input className="form-check-input" type="checkbox" value="1"
                        defaultChecked={true} />
									<span className="form-check-label fw-semibold text-muted">Allowed</span>
								</label>
							</div>
							<div className="mb-15 fv-row">
								<div className="d-flex flex-stack">
									<div className="fw-semibold me-5">
										<label className="fs-6">Notifications</label>
										<div className="fs-7 text-muted">Allow Notifications by Phone or Email</div>
									</div>
									<div className="d-flex align-items-center">
										<label className="form-check form-check-custom form-check-solid me-10">
											<input className="form-check-input h-20px w-20px" type="checkbox" name="communication[]" value="email"
                        defaultChecked={true}
                       />
											<span className="form-check-label fw-semibold">Email</span>
										</label>
										<label className="form-check form-check-custom form-check-solid">
											<input className="form-check-input h-20px w-20px" type="checkbox" name="communication[]" value="phone"
                       />
											<span className="form-check-label fw-semibold">Phone</span>
										</label>
									</div>
								</div>
							</div>
							<div className="text-center">
								<button type="reset" id="kt_modal_new_target_cancel" className="btn btn-light me-3">Cancel</button>
								<button type="submit" id="kt_modal_new_target_submit" className="btn btn-primary">
									<span className="indicator-label">Submit</span>
									<span className="indicator-progress">Please wait...
									<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

      <table className='table table-striped gy-7 gs-7 d-none'>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => {
                return (
                  <th key={header.id} colSpan={header.colSpan} style={{ width: widthData[index] }}>
                    {header.isPlaceholder ? null : (
                      <div className='fw-bold fs-7 text-gray-1200 border-bottom-2 border-gray-200'>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                      </div>
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  )
                })}
                {/**add button เพิ่มปุ่ม */}
                {/*<td>
                  <button type='button' className='btn btn-primary' onClick={() => {editItem(row)}}>
                    Edit
                  </button>
                  <span> </span>
                  <button type='button' className='btn btn-primary' onClick={() => {}}>
                    Delete
                  </button>
                </td>*/}
                
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className='h-2' />

      <Card.Footer>
        <span className='flex items-center gap-1 d-none'>
          <strong>
            Page {page} of {totalPage}
          </strong>
        </span>
        <span className='flex items-center gap-1 mr-3 p-4 d-none'>
          | Go to page:
          <input
            type='number'
            defaultValue={page}
            value={page}
            onChange={(e) => {
              if (Number(e.target.value) <= totalPage && Number(e.target.value) > 0) {
                /*const page = e.target.value ? Number(e.target.value) - 1 : 0
                table.setPageIndex(page)*/
                setPage(Number(e.target.value))
                refreshAPI(Number(e.target.value), limit)
              }
            }}
            className='border p-1 rounded w-16'
          />
        </span>
        <span className='d-none'>
          <select
            className='ml-2'
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value))
              refreshAPI(page, Number(e.target.value))
              table.setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </span>
      </Card.Footer>
    </Card>
  )
}
